import React, {Component} from "react";

import WithUserData from "../WithUserData";

export default class MissingMembership extends Component {
    handleExternalLink = () => {
        let withinSchmodelAppWebview = false;

        try {
            const raw = window.ReactNativeWebView?.injectedObjectJson?.();
            if (raw) {
                const parsed = JSON.parse(raw);
                withinSchmodelAppWebview = !!parsed.withinSchmodelApp;
            }
        } catch (e) {
            withinSchmodelAppWebview = false;
        }

        const url = window.location.origin;
        if (withinSchmodelAppWebview && window.ReactNativeWebView?.postMessage) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    type: "externalLink",
                    url
                })
            );
        } else {
            window.open(url, "_blank");
        }
    };

    render() {
        return (
            <WithUserData>
                {() => {
                    return (
                        <div className={`w-full h-full flex justify-center items-center`}>
                            <p className='text-black text-center text-lg'>
                                You haven't chosen a <br />
                                membership yet! <br /><br />
                                Go to <span className="underline cursor-pointer" onClick={this.handleExternalLink}>schmodel.com</span> <br />
                                and click Login to <br />
                                complete the creation of <br />
                                your Schmodel account.
                            </p>
                        </div>
                    )
                }}
            </WithUserData>
        );
    }
}
